import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.object.to-string.js";
import { isNotUndefined } from "@faire/web/common/typescriptUtils";
import compareDesc from "date-fns/compareDesc";
export var getLatestDataUpdatedAt = function getLatestDataUpdatedAt(allDataUpdatedAt) {
  return allDataUpdatedAt.filter(isNotUndefined).sort(compareDesc)[0];
};